import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { parseEnumToInputOption } from '../../../../../../helpers/enum-parser';
import { Dispatch, SetStateAction } from 'react';

export enum SuppliersSortingType {
  priceAscending = 'Price ascending',
  priceDescending = 'Price descending',
}

export const SortingDropdown = ({
  sortingValue,
  setSortingValue,
}: {
  sortingValue: string;
  setSortingValue: Dispatch<SetStateAction<string>>;
}) => {
  const sortingOptions = parseEnumToInputOption(SuppliersSortingType);

  return (
    <FormControl size="small" style={{ width: 'fit-content' }}>
      <InputLabel id="sorting">Sorting</InputLabel>
      <Select
        labelId="sorting"
        id="sorting"
        value={
          sortingValue !== ''
            ? sortingValue
            : SuppliersSortingType.priceAscending
        }
        label="Sorting"
        onChange={(e) => setSortingValue(e.target.value)}
        style={{ width: '190px' }}
      >
        {sortingOptions.map((item) => (
          <MenuItem value={item.value} key={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
